import React, { PropsWithChildren, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { KeyboardAvoidingView } from 'react-native';
import { Platform } from 'react-native';

interface Props {
};

export function CustomKeyboardAvoidingView({ children, ...props }: PropsWithChildren<Props>) : React.ReactNode {
  const modifiedProps: any = Object.assign({}, props);
  // https://docs.expo.dev/guides/keyboard-handling/
  if (Platform.OS === "ios") {
    modifiedProps.behavior = "padding";
  }
  return (
    <KeyboardAvoidingView
      {...modifiedProps}
      style={[AppConstants.STYLES.flex1, modifiedProps]}
    >
      { children }
    </KeyboardAvoidingView>
  );
};
